// PRC-029: Política de privacidad con la plantilla de lectura. Solo afirma lo
// que es verdad hoy; la redacción legal definitiva llega con PRC-012 (abogado).
import React from 'react';
import DocPage, { DocList, DocNote, DocP } from '../modules/pricingJourney/components/DocPage';

const UPDATED = '3 de noviembre de 2026';
const CONTACT_EMAIL = 'soporte@proapricing.ai';
// PRC-029: hueco pendiente; Pablo lo mira en Supabase › Project Settings › General.
const SUPABASE_REGION = '[REGIÓN DE SUPABASE: la confirma Pablo]';

const SECTIONS = [
  {
    id: 'datos',
    title: 'Qué datos tratamos y para qué',
    content: (
      <>
        <DocP>Tratamos solo la información necesaria para prestar el servicio:</DocP>
        <DocList items={[
          <><b>Datos de acceso:</b> nombre, email de trabajo, empresa y rol, para crear la cuenta y gestionar quién entra.</>,
          <><b>Datos comerciales:</b> histórico de ventas, costes, productos y clientes que tu empresa carga. Se usan exclusivamente para calcular sus análisis, recomendaciones de precio y previsiones.</>,
          <><b>Datos técnicos:</b> registros de funcionamiento para mantener el servicio estable y detectar errores.</>,
        ]} />
        <DocP>No vendemos datos a terceros.</DocP>
      </>
    ),
  },
  {
    id: 'aislamiento',
    title: 'Aislamiento y seguridad',
    content: (
      <>
        <DocP>Cada cuenta solo puede acceder a sus propios datos; el servidor lo comprueba en cada petición.</DocP>
        <DocP>Las comunicaciones van cifradas (HTTPS) y la base de datos está cifrada en reposo por nuestro proveedor.</DocP>
      </>
    ),
  },
  {
    id: 'modelos',
    title: 'Modelos',
    content: (
      <DocP>Los modelos se entrenan por cuenta. Sus datos nunca se usan para entrenar modelos de otros clientes.</DocP>
    ),
  },
  {
    id: 'ubicacion',
    title: 'Dónde están los datos y proveedores',
    content: (
      <>
        <DocP>Los servidores de la aplicación están en Madrid (Google Cloud) y la base de datos en Supabase, región {SUPABASE_REGION}.</DocP>
        <DocP>Para prestar el servicio trabajamos con estos proveedores:</DocP>
        <DocList items={[
          <><b>Google Cloud:</b> servidores de la aplicación.</>,
          <><b>Supabase:</b> base de datos y acceso de usuarios.</>,
          <><b>Stripe:</b> pagos y facturación.</>,
          <><b>Resend:</b> envío de emails (confirmación de cuenta, contraseña).</>,
          <><b>OpenAI:</b> interpretar las preguntas de la consulta comercial. Solo recibe el texto de la pregunta y el periodo, nunca datos de ventas, clientes ni precios.</>,
        ]} />
      </>
    ),
  },
  {
    id: 'derechos',
    title: 'Tus derechos',
    content: (
      <>
        <DocP>Puedes ejercer en cualquier momento los derechos de acceso, rectificación, supresión, limitación del tratamiento y portabilidad de tus datos, y pedir una exportación o la eliminación de tu cuenta.</DocP>
        <DocNote>
          Escríbenos a <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: '#7dd3fc' }}>{CONTACT_EMAIL}</a> para cualquier consulta sobre privacidad o para ejercer tus derechos.
        </DocNote>
      </>
    ),
  },
];

const PrivacyPolicyPage: React.FC = () => (
  <DocPage
    eyebrow="Legal"
    title="Política de privacidad"
    updated={UPDATED}
    intro="Cómo tratamos los datos de tu empresa y los de las personas que usan PROA Pricing."
    sections={SECTIONS}
  />
);

export default PrivacyPolicyPage;
